import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, withStyles, AppBar, Typography, Toolbar } from 'material-ui';
import EditPassengersHeaderStyles from './EditPassengerHeaderStyles';
import ArrowLeftIcon from '../../../../icons/ArrowLeftIcon';

const EditPassengersHeader = ({ title, handleClose, classes }) => (
  <AppBar
    position='static'
    style={{
      marginBottom: 20,
      width: '100%',
      backgroundColor: 'transparent',
      color: 'rgba(0, 0, 0, 0.54)',
    }}
  >
    <Toolbar>
      <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
        <ArrowLeftIcon className='navbar-arrow-icon' color='rgba(0, 0, 0, 0.54)' />
      </IconButton>
      <Typography type='title' color='inherit' className={classes.flex}>
        {title}
      </Typography>
    </Toolbar>
  </AppBar>
);

EditPassengersHeader.propTypes = {
  title: PropTypes.string,
  handleClose: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(EditPassengersHeaderStyles)(EditPassengersHeader);



// WEBPACK FOOTER //
// ./src/containers/passengers/common/editPassenger/EditPassengerHeader.js